/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Summary_Memory_AllInputs */



/**
* | output |
* | --- |
* | "For all {count} colleagues, Wundo helps you prepare and keeps track of what you've discussed." |
*
* @param {Team_Summary_Memory_AllInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_summary_memory_all = /** @type {((inputs: Team_Summary_Memory_AllInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Summary_Memory_AllInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bij elk van hen helpt Wundo je bij de voorbereiding en houdt het de rode draad bij.")
	if (locale === "fr") return /** @type {LocalizedString} */ (`Pour chacun de vos ${i?.count} collègues, Wundo vous aide à préparer et garde le fil de vos échanges.`)
	return /** @type {LocalizedString} */ (`For all ${i?.count} colleagues, Wundo helps you prepare and keeps track of what you've discussed.`)
});